import type { FC } from 'react';
import React from 'react';
import { styled } from '@compiled/react';

import Avatar, { AvatarContent } from '@atlaskit/avatar';
import Image from '@atlaskit/image';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IconContainer = styled.div({
	width: '30px',
	height: '30px',
});

type TemplateCardIconProps = {
	iconURL: string;
	darkModeIconURL: string | null;
};

export const TemplateIcon: FC<TemplateCardIconProps> = ({ iconURL, darkModeIconURL }) => {
	return (
		<IconContainer>
			<Avatar appearance="square" size="small">
				<AvatarContent>
					<Image alt="" src={iconURL || ''} srcDark={darkModeIconURL || ''} />
				</AvatarContent>
			</Avatar>
		</IconContainer>
	);
};
